<template>
    <!-- Wrapper -->
    <div class="wrapper">
		<!-- Small screen detector (mobile) -->
		<div v-b-visible="handleSmallScreen" class="d-md-none"></div>
        <!-- Sidebar Navigation -->
        <side-nav :options="menuOption">
            <template #header>
				<router-link to="/" class="text-decoration-none text-white">
                <h3>
                    <img
                        src="@/assets/app_icon.png"
                        height="32px"
                        style="color: white"
                    />
                    SiRoLeg
                </h3>
                <h6>versi {{ $store.getters.version }}</h6>
				</router-link>
            </template>
        </side-nav>
        <!-- The content section houses page contents -->
        <div id="content" :class="[{ active: $store.getters.sidebar, mobile: mobileScreen }]">
            <vuescroll :ops="scrollOptions" ref="contentView" >
                <div class="py-3">
                    <!-- Real container -->
                    <b-container fluid id="contents-section">
                        <!-- Navbar -->
                        <navbar />
                        <!-- Breadcrumb -->
                        <breadcrumb class="my-2" />
                        <!-- <span class="h4" v-if="$route.meta.title">{{ this.$route.meta.title }}</span>
            <hr />-->
                        <h4
                            v-if="pageTitle"
                            class="p-1"
                            style="
                                text-shadow: 1px 2px 12px
                                    rgba(125, 125, 225, 0.5);
                            "
                        >
                            {{ pageTitle }}
                        </h4>
                        <hr />

                        <!-- Per route view -->
                        <router-view></router-view>

                        <hr />
                        <app-footer />
                    </b-container>
                </div>
            </vuescroll>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import Navbar from "@/components/Navbar";
import SideNav from "@/components/SideNav";
import Breadcrumb from "@/components/Breadcrumb";
import AppFooter from "@/components/AppFooter";

import vuescroll from "vuescroll";

import userChecker from "../mixins/userChecker";
import appMethod from "../mixins/appMethod";
import menuGenerator from "../mixins/menuGenerator";

// import menuInput from "@/assets/menu.json";
// import module menu
import { generateMenu, structure } from '../libs/menu'

export default {
    mixins: [userChecker, appMethod, menuGenerator],

    methods: {
		...mapMutations(['setMobileScreen']),

        checkRole(roles) {
            var result = this.$store.getters.hasRole(roles);
            // console.log("Checking roles: ", roles, "result: ", result)
            // console.log("Checking against: ", this.$store.getters.roles)
            console.log(
                "Checking roles [ ",
                roles,
                "] <-> ",
                this.$store.getters.roles,
                " : ",
                result
            );
            return result;
        },

		handleSmallScreen(isSmall) {
			this.setMobileScreen(isSmall)
		}
    },

    computed: {
		...mapGetters(['mobileScreen']),

        pageTitle() {
            // override if query is set
            return this.$route.query.title || this.$route.meta.title;
        },

        menuOption() {
            /* var result = [];
            menuInput.forEach((e) => {
                this.processElement(result, e);
            });
            return result; */
			return generateMenu(structure, this.checkRole)
        },

        scrollOptions() {
            return {
                bar: {
                    background: "#aaa",
                },
                scrollPanel: {
                    scrollingX: false,
                },
            };
        },
    },

    components: {
        Navbar,
        SideNav,
        Breadcrumb,
        vuescroll,
        AppFooter,
    },

	watch: {
		'$store.state.scrollToElement': {
			handler(el) {
				console.log('NEED SCROLLING TO : ', el)

				// ok, scroll to there
				if (this.$refs['contentView'] && el) {
					this.$nextTick(() => {
						this.$refs['contentView'].scrollTo(
						{
							y: el.offsetTop
							},
							500
						)

						// clear scrollto
						this.$store.commit('setScrollToElement', null)
					})
				}
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/views/MainApp.vue